import { makeAutoObservable } from 'mobx';
import fetchUserVoteCounts from './fn/fetchUserVoteCounts';
import getIsLoading from './fn/getIsLoading';
import { AdminReportUserVoteCount } from '~/definitions/adminReport';

export default class AdminReportStore {
    userVoteCounts: AdminReportUserVoteCount[] = [];
    isLoadingUserVoteCounts: boolean = false;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.userVoteCounts = [];
        this.isLoadingUserVoteCounts = false;
    }

    setUserVoteCounts = (userVoteCounts: typeof this.userVoteCounts) => {
        this.userVoteCounts = userVoteCounts;
    };
    setIsLoadingUserVoteCounts = (isLoadingUserVoteCounts: typeof this.isLoadingUserVoteCounts) => {
        this.isLoadingUserVoteCounts = isLoadingUserVoteCounts;
    };

    fetchUserVoteCounts = fetchUserVoteCounts;
    getIsLoading = getIsLoading;
}
